import React from "react";

// w-full + min-w-0 keep the select bounded by its container instead of
// growing to fit the widest <option> — without these a long-named option
// (e.g. an office name) blew out grid cells and forced horizontal scroll.
//
// Key uses index, not value. If two options share the same v (transiently
// possible when callers build the list from un-deduped data — e.g. payroll
// runs across multiple companies all with period '2026-04'), keying on v
// produced duplicate React keys, and reconciliation kept stale <option>
// DOM nodes around even after the caller filtered the list down. Indexing
// keys keeps the option list always identity-correct.
//
// Optional `w` prop: pass a number (px) or a CSS width string to size
// the select to a specific width instead of filling its container.
// Used for inline filter bars where the default w-full would either
// stretch the dropdown across the screen or wrap onto its own row.
//   <Sl w={110} … />   → 110px wide
//   <Sl w="9rem" … />  → 9rem wide
export const Sl = ({ options, value, onChange, w, disabled, bg, error }) => {
  const fixed = w !== undefined && w !== null;
  // Long option labels (an office/department name, a workflow field label)
  // get clipped by the select's fixed width — a native title tooltip on
  // hover shows the full text, matching the dark truncation tooltip Zoho
  // shows on its own long dropdown options.
  const selectedLabel = options.find((o) => String(o.v) === String(value))?.l;
  return (
    <select
      value={value}
      disabled={disabled}
      onChange={e => onChange(e.target.value)}
      title={selectedLabel}
      style={fixed ? { width: typeof w === 'number' ? `${w}px` : w, flex: 'none' } : undefined}
      className={`${fixed ? 'min-w-0' : 'w-full min-w-0'} px-[10px] py-[7px] ${bg || "bg-bg2"} border ${error ? "border-r" : "border-b0"} rounded-[10px] text-t0 text-[14px] outline-none ${disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"}`}
    >
      {options.map((o, i) => <option key={`${i}-${o.v}`} value={o.v} title={o.l}>{o.l}</option>)}
    </select>
  );
};
